<app-slide-in-right-modal
  [modalTitle]="reportTitle"
  iconImageSrc="assets/images/svgs/document--outline.svg"
  [slideOpen]="true"
  [returnPath]="returnPathUrl"
>
  <div class="page__container flex flex-col pb-8">
    <p class="cta__text text-sm text-mango-gray74">
      Kindly select a date range to generate report
    </p>

    <form class="flex flex-col gap-5 px-0 pt-5" [formGroup]="dateRangeForm">

      <!-- Date mode toggle -->
      <div class="flex flex-col gap-2">
        <div class="flex flex-col gap-3 sm:flex-row">

          <!-- Report Till Date button -->
          <button
            mango-button
            type="button"
            (click)="selectTillDate()"
            [disabled]="isCustomMode"
            [ngClass]="{
              'bg-mango text-white border-mango': isTillDateMode,
              'bg-mango/90 text-white/90 border-mango/90': !isTillDateMode,
              'opacity-40 cursor-not-allowed': isCustomMode
            }"
            class="flex flex-1 items-center justify-center"
          >
            <span *ngIf="isFetchingAccount" spin></span>
            Since Inception
          </button>

          <!-- Start Date & End Date button -->
          <button
            mango-button
            type="button"
            (click)="selectCustom()"
            [disabled]="isTillDateMode"
            [ngClass]="{
              'bg-mango text-white border-mango': isCustomMode,
              'bg-mango/90 text-white/90 border-mango/90': !isCustomMode,
              'opacity-40 cursor-not-allowed': isTillDateMode
            }"
            class="flex flex-1 items-center justify-center"
          >
            Start Date &amp; End Date
          </button>

        </div>
      </div>

      <!-- Till Date info banner -->
      <div
        *ngIf="isTillDateMode && accountCreatedAt"
        class="flex items-center gap-2 rounded-lg bg-blue-50 px-4 py-3 text-sm text-blue-700"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="h-4 w-4 shrink-0"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
          />
        </svg>
        Report will cover
        <strong class="mx-1">{{ accountCreatedAt }}</strong>
        to today.
      </div>

      <!-- Custom date inputs -->
      <div
        *ngIf="isCustomMode"
        class="form-row flex flex-col gap-5 md:grid md:grid-cols-2 md:gap-x-5"
      >
        <!-- Start date -->
        <div>
          <app-input-label labelFor="start-date" labelClass="label--bottom-margin">
            Start Date
          </app-input-label>
          <input
            id="start-date"
            placeholder="DD/MM/YYYY"
            formControlName="start_date"
            class="block w-full cursor-pointer rounded-lg border-0 pl-2 text-base text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-mango sm:leading-6"
            type="date"
          />
        </div>

        <!-- End date -->
        <div>
          <app-input-label labelFor="end-date" labelClass="label--bottom-margin">
            End Date
          </app-input-label>
          <input
            id="end-date"
            placeholder="DD/MM/YYYY"
            formControlName="end_date"
            class="block w-full cursor-pointer rounded-lg border-0 pl-2 text-base text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-mango sm:leading-6"
            type="date"
          />
        </div>
      </div>

      <!-- Generated report link -->
      <button
        *ngIf="reportUrl"
        (click)="openDocument(reportUrl)"
        [title]="reportTitle"
        class="flex cursor-pointer items-center gap-3 rounded-lg bg-mango-lightOrange px-[0.88rem] py-3 shadow-sm"
      >
        <img src="assets/images/svgs/file-text.svg" alt="" class="h-6 w-6" />
        <span class="flex flex-col overflow-hidden text-ellipsis whitespace-nowrap text-sm font-medium">
          <span class="overflow-hidden text-ellipsis">{{ reportTitle }}</span>
        </span>
        <div class="ml-auto inline-flex gap-2">
          <span>View</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="h-5 w-5 shrink-0"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
            />
          </svg>
        </div>
      </button>

      <!-- Action buttons (visible only after a mode is selected) -->
      <div *ngIf="dateMode" class="w-full">
        <div
          class="flex w-full flex-col gap-3 sm:flex-row"
          [ngClass]="{ 'cursor-not-allowed': isLoadingReport || isLoadingReportSend }"
        >
          <button
            (click)="getReport('report_and_email')"
            class="w-full justify-center xl:col-start-2 xl:w-fit xl:justify-self-end"
            mango-button
            [disabled]="isLoadingReportSend || !isFormReady || isFetchingAccount"
          >
            <span *ngIf="isLoadingReportSend" spin></span>
            {{ isLoadingReportSend ? 'Generating and Sending...' : 'Generate and Send Report' }}
          </button>

          <button
            (click)="getReport('report_only')"
            class="flex-1 justify-center"
            mango-button
            [disabled]="isLoadingReport || !isFormReady || isFetchingAccount"
          >
            <span *ngIf="isLoadingReport" spin></span>
            {{ isLoadingReport ? 'Generating...' : 'Generate Report' }}
          </button>
        </div>
      </div>

    </form>
  </div>
</app-slide-in-right-modal>